import React, { useState } from 'react';
import { Box, Button, Container, Grid, ListItemButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import AddIcon from '@mui/icons-material/Add';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import { useNavigate } from 'react-router';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddVideoCategoryDialog from '../components/dialog/AddVideoCategoryDialog';
import { VideoCategory } from '../types/transport';
import { useStore } from '../store/context';

const VideoCategoryPage = observer((): JSX.Element => {
  const [showAddVideo, setShowAddVideo] = useState(false);
  const [currentCategory, setCurrentCategory] = useState<VideoCategory>();

  const navigate = useNavigate();
  const navigateToCategory = (id: string) => {
    navigate(`${id}`);
  };

  const { videoCategoryStore, videoStore } = useStore();

  const addCategory = async (category: VideoCategory) => {
    await videoCategoryStore?.updateVideoCategory(category.uuid, category);
    setShowAddVideo(false);
  };

  const editCategory = (category: VideoCategory) => {
    setCurrentCategory(category);
    setShowAddVideo(true);
  };

  const deleteCategory = async (category: VideoCategory) => {
    try {
      const deletableVideos = videoStore?.allEntries.filter(
        video => video.category === category.title,
      );
      if (deletableVideos && deletableVideos.length > 0) {
        await Promise.all(
          deletableVideos?.map(video =>
            videoStore?.updateVideoCategory(video.uuid, null),
          ),
        );
      }
      await videoCategoryStore?.updateVideoCategory(category.uuid, null);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Container sx={{ marginLeft: '240px', width: '100%' }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Button
            variant="contained"
            onClick={() => setShowAddVideo(true)}
            endIcon={<AddIcon />}
          >
            Neue Kategorie hinzufügen
          </Button>
          <List
            sx={{
              width: '100%',
              bgcolor: 'background.paper',
            }}
          >
            {videoCategoryStore?.allEntries.map(category => (
              <Grid container key={category.uuid}>
                <Grid item xs={3}>
                  <ListItemButton
                    onClick={() => navigateToCategory(category.uuid)}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <ImageIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={category.title}
                      secondary={`${new Date(
                        category.createdAt,
                      ).toLocaleDateString()} ${new Date(
                        category.createdAt,
                      ).toLocaleTimeString()}`}
                    />
                  </ListItemButton>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <Button
                    onClick={() => editCategory(category)}
                    endIcon={<EditIcon />}
                  />
                  <Button
                    onClick={() => deleteCategory(category)}
                    endIcon={<DeleteIcon />}
                  />
                </Grid>
              </Grid>
            ))}
          </List>
        </Box>
        {showAddVideo && (
          <AddVideoCategoryDialog
            currentCategory={currentCategory}
            onSave={category => addCategory(category)}
            onClose={() => setShowAddVideo(false)}
          />
        )}
      </Container>
    </>
  );
});

export default VideoCategoryPage;
